import {
CdkVirtualScrollViewport,
FixedSizeVirtualScrollStrategy,
VIRTUAL_SCROLL_STRATEGY,
} from '@angular/cdk/scrolling';
import { AsyncPipe,DatePipe } from '@angular/common';
import {
Component,
Inject,
Input,
OnInit,
ViewChild
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import {
MatDialog,
MatDialogModule,
MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginator,PageEvent } from '@angular/material/paginator';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterLink } from '@angular/router';
import { Observable,Subscriber } from 'rxjs';
import {
AuthenticationService,
AuthenticationServiceToken,
CorrFilterServiceToken,
LogServiceToken,
MapperServiceToken,
RepositoryServiceToken,
} from '../../services';
import {
ICorrFilterService,
ILogService,
IMapperService,
IRepositoryService
} from '../../services/i';
import {
CorrCountViewModel,
CorrespondenceViewModel as VMCorr,
} from '../../view-models';
import {
CorrespondenceFilterViewModel as CorFilter,
CorrCountFilterViewModel,
} from '../../view-models/filters';
import { HeaderComponent } from '../header/header.component';
import { FilterViewerComponent } from './filter-viewer/filter-viewer.component';
import { FilterDialog } from './filter.dialog';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [
    {
      provide: VIRTUAL_SCROLL_STRATEGY,
      useValue: new FixedSizeVirtualScrollStrategy(50, null, null),
    },
  ],
  imports: [
    HeaderComponent,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    FilterViewerComponent,
    AsyncPipe,
    MatDialogModule,
    RouterLink,
    MatPaginator,
    DatePipe,
  ],
  standalone: true,
})
export class DashboardComponent implements OnInit {
  dialogRef: MatDialogRef<FilterDialog>;
  @Input() savedFilterName: string;
  @Input() filter: CorFilter;
  correspondences: VMCorr[] = [];
  corrObs: Observable<VMCorr[]>;
  corrObs$: Subscriber<VMCorr[]>;
  noAccessDashboard: boolean;
  loading = false;
  limit = 10;
  @ViewChild(CdkVirtualScrollViewport)
  viewport: CdkVirtualScrollViewport;
  page: PageEvent;
  totalItems = 0;

  constructor(
    public dialog: MatDialog,
    @Inject(RepositoryServiceToken) private repo: IRepositoryService,
    @Inject(AuthenticationServiceToken) private auth: AuthenticationService,
    @Inject(LogServiceToken) private log: ILogService,
    @Inject(CorrFilterServiceToken) private corrFilterSvc: ICorrFilterService,
    @Inject(MapperServiceToken) private mapper: IMapperService
  ) {
    this.corrObs = new Observable(subscriber => {
      this.corrObs$ = subscriber;
    });
  }

  ngOnInit() {
    this.noAccessDashboard = !this.auth.hasAnyRole(
      'Shepherd',
      'Reviewer',
      'Intake',
      'Admin'
    );
    this.filter = this.rememberFilter();
    this.refreshPaging();
    this.refreshCorrespondences();
  }

  rememberFilter(filter?: CorFilter): CorFilter {
    const storageKey = 'edu.uiowa.ITS.CorTrack.filter';
    if (filter) {
      localStorage[storageKey] = JSON.stringify(filter);
      this.filter = filter;
    }

    if (this.filter) {
      return this.filter;
    } // passed in as input

    try {
      const json = localStorage[storageKey];
      const f = JSON.parse(json);
      return this.mapper.MapJsonToVM(CorFilter, f);
    } catch (err) {
      return new CorFilter();
    }
  }

  refreshPaging() {
    this.filter.Page = 0;
    this.filter.PageSize = this.limit;
    const cfilter = new CorrCountFilterViewModel();
    cfilter.Filters = [this.filter];
    this.repo
      .Page(CorrCountViewModel, cfilter)
      .toPromise()
      .then(c => {
        this.totalItems = c[0].Count;
      });
  }

  refreshFilter(filter: CorFilter): void {
    this.rememberFilter(filter);
    this.refreshPaging();
    this.refreshCorrespondences();
  }

  openDialog(): void {
    this.dialogRef = this.dialog.open(FilterDialog, {
      disableClose: false,
    });
    this.dialogRef.componentInstance.filter = this.mapper.MapJsonToVM(
      CorFilter,
      this.filter
    );
    this.dialogRef.componentInstance.savedFilterName = this.savedFilterName;
    this.dialogRef
      .afterClosed()
      .toPromise()
      .then(result => {
        this.refreshFilter(result);
        this.refreshPaging();
        this.dialogRef = null;
      });
  }

  refreshCorrespondences() {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.repo
      .Page(VMCorr, this.filter)
      .toPromise()
      .then(chunk => {
        this.loading = false;
        return chunk;
      })
      .then(chunk => {
        this.corrObs$.next(chunk);
        this.correspondences = this.correspondences.concat(chunk);
      });
  }

  setPage($event: PageEvent) {
    this.filter.Page = $event.pageIndex;
    this.filter.PageSize = $event.pageSize;
    this.refreshCorrespondences();
  }
}
